// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"8eaf5b02","107":"e1e7ebf6","210":"5e33a11a","527":"8d552752","646":"ac7e9296"}[chunkId] + ".chunk.css";
};